export const RSVP = {
    cta: "rsvp-cta",
    sheet: "rsvp-sheet",
    close: "rsvp-sheet-close",
    fieldName: "rsvp-name",
    fieldType: "rsvp-type",
    fieldAttending: "rsvp-attending",
    fieldPlusOne: "rsvp-plus-one",
    fieldPlusOneName: "rsvp-plus-one-name",
    dietChip: (k) => `rsvp-diet-${k}`,
    fieldAllergies: "rsvp-allergies",
    fieldNotes: "rsvp-notes",
    submit: "rsvp-submit",
    success: "rsvp-success",
};

export const ADMIN = {
    loginRoot: "admin-login-root",
    loginCodeField: "admin-login-code",
    loginSubmit: "admin-login-submit",
    dashboardRoot: "admin-dashboard-root",
    statTotal: "stat-total",
    statAdults: "stat-adults",
    statChildren: "stat-children",
    statBabies: "stat-babies",
    statAllergies: "stat-allergies",
    statDiet: (k) => `stat-diet-${k}`,
    searchField: "admin-search",
    typeFilter: (k) => `admin-filter-type-${k}`,
    addGuestBtn: "admin-add-guest",
    guestRow: (id) => `guest-row-${id}`,
    guestEdit: (id) => `guest-edit-${id}`,
    guestDelete: (id) => `guest-delete-${id}`,
    guestModal: "admin-guest-modal",
    guestModalClose: "admin-guest-modal-close",
    guestSave: "admin-guest-save",
    logoutBtn: "admin-logout",
};
